var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlackStar = function SvgBlackStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.8,
    d: "M6.122 1.087a.4.4 0 0 1 .756 0l1.176 3.385a.4.4 0 0 0 .37.268l3.583.073a.4.4 0 0 1 .233.72L9.385 7.696a.4.4 0 0 0-.141.435l1.037 3.43a.4.4 0 0 1-.611.444L6.728 9.959a.4.4 0 0 0-.456 0L3.33 12.006a.4.4 0 0 1-.611-.444l1.037-3.43a.4.4 0 0 0-.14-.435L.76 5.532a.4.4 0 0 1 .233-.719l3.583-.073a.4.4 0 0 0 .37-.268z"
  })));
};
export default SvgBlackStar;